<template>
    <footer class="audit-footer">
      <div class="pc-container">
        <div class="foot-personal">
          <button type="button" class="foot-personal-btn" @click="open()">개인정보 처리방침</button>
        </div>
        <div class="foot-desc">
        <span class="logo">
          <img src="../img/audit-footer-logo.png" alt="동아쏘시오 사이버감사실">
        </span>
        <address class="foot-address">서울시 동대문구 천호대로 64 TEL. 02-920-8114<br>Copyright DONG-A SOCIO HOLIDINGS. All right reserved.</address>
        <span class="iso-logo">
          <button @click="showISO=true"><img src="../img/iso27001.png" alt="ISO 27001"></button>
        </span>
        </div>
        <modal v-if="showModal" @close="showModal=false">
            <h3 slot="body">
                <div class="form-modal-container personal-popup">
                  <p class="personal-header">감사 제보시스템 개인정보 처리방침<br><br>
                  동아쏘시오홀딩스(이하 “회사”)는 동아쏘시오그룹 감사 제보시스템(이하 “CLEAN:D”)를 운영하며<br>
                  정보주체의 자유와 권리 보호를 위해 「개인정보 보호법」 및 관계 법령이 정한 바를 준수하여, <br>
                  적법하게 개인정보를 처리하고 안전하게 관리하고 있습니다. 이에 「개인정보 보호법」 제30조에 따라 <br>
                  정보주체에게 개인정보의 처리와 보호에 관한 절차 및 기준을 안내하고, <br>
                  이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록 하기 위하여 다음과 같이 개인정보 처리방침을 수립・공개합니다.</p>
                  <br><br>
                  <p class="personal-title">1. 개인정보의 처리목적, 수집 항목, 보유 및 이용기간</p><br>
                  <p class="personal-txt">1) 회사는 「개인정보 보호법」에 따라 CLEAN:D 서비스 제공을 위해 필요 최소한의 범위에서 개인정보를 처리합니다. 처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 「개인정보 보호법」 제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.</p>
                  <br>
                  <table>
                    <thead>
                      <tr>
                        <th style="text-align: center">처리근거</th>
                        <th style="text-align: center">구분</th>
                        <th style="text-align: center">처리 목적</th>
                        <th style="text-align: center">처리 항목</th>
                        <th style="text-align: center">보유 및 이용기간</th>
                      </tr>
                    </thead>
                    <tbody>
                    <tr>
                      <td>개인정보보호법 제15조제1항제1호(동의)</td>
                      <td>실명제보</td>
                      <td>
                      - 실명제보 접수 내용의 사실관계 확인
                      <br>- 실명제보 처리 결과 안내
                      <br>- 실명제보 처리 결과에 따른 포상
                      <br>- 실명제보 처리 결과에 따른 형사 조치(고소•고발) 시 인적증거 등록
                      </td>
                      <td>이름, 이메일, 전화번호</td>
                      <td>처리목적 달성 시</td>
                    </tr>
                  </tbody>
                  </table><br><br>
                  <p class="personal-title">2. 개인정보의 파기 절차 및 방법</p><br>
                  <p class="personal-txt">1) 회사는 개인정보 보유기간의 경과, 처리목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체없이 해당 개인정보를 파기합니다.<br>
                      2) 정보주체로부터 동의받은 개인정보 보유기간이 경과하거나 처리목적이 달성되었음에도 불구하고 다른 법령에 따라 개인정보를 계속 보존하여야 하는 경우에는, 해당 개인정보를 별도의 데이터베이스(DB)로 옮기거나 보관장소를 달리하여 보존합니다.<br>
                      3) 개인정보 파기의 절차 및 방법은 다음과 같습니다.<br>
                      </p>
                  <p class="detail-sub-txt">
                    (1) 파기절차<br>
                    회사는 파기 사유가 발생한 개인정보를 선정하고, 회사의 개인정보 보호책임자의 승인을 받아 개인정보를 파기합니다.<br>
                    (2) 파기방법<br>
                    회사는 전자적 파일 형태로 기록・저장된 개인정보는 기록을 재생할 수 없도록 파기하며, 종이 문서에 기록・저장된 개인정보는 분쇄기로 분쇄하거나 소각하여 파기합니다.<br>
                 </p>
                 <br><br>
                  <p class="personal-title">3. 개인정보의 제3자 제공</p><br>
                  <p class="personal-txt">
                      1) 회사는 정보주체의 개인정보를 개인정보의 처리목적에서 명시한 범위 내에서만 처리하며, 정보주체의 동의, 법률의 특별한 규정 등 「개인정보 보호법」 제17조 및 제18조에 해당하는 경우에만 개인정보를 제3자에게 제공하고 그 이외에는 정보주체의 개인정보를 제3자에게 제공하지 않습니다.<br>
                      2) 회사는 원활한 CLEAN:D 서비스 제공을 위해 다음의 경우 「개인정보 보호법」 제17조제1항제1호에 따라 정보주체의 동의를 얻어 필요 최소한의 범위로만 제공합니다.
                  </p>
                  <table>
                    <colgroup>
                       <col width="25%">
                        <col width="25%">
                        <col width="25%">
                        <col width="25%">
                    </colgroup>
                     <thead>
                      <tr>
                          <th style="text-align: center">제공받는 자</th>
                          <th style="text-align: center">제공목적</th>
                          <th style="text-align: center">제공항목</th>
                          <th style="text-align: center">보유 및 이용기간</th>
                     </tr>
                    </thead>
                        <tbody>
                        <tr>
                        <td>동아에스티, 동아제약, 에스티젠바이오, 동아오츠카, 용마로지스, 에스티팜, 수석, 한국신동공업, 동천수, 동아참메드, 앱티스, 디에이인포메이션, 아벤종합건설</td>
                        <td>- 실명제보 접수 내용의 사실관계 확인
                        <br>- 실명제보 처리 결과 안내
                        <br>- 실명제보 처리 결과에 따른 포상
                        <br>- 실명제보 처리 결과에 따른 형사 조치(고소•고발) 시 인적증거 등록
                        </td>
                        <td>이름, 이메일, 전화번호
                        </td>
                        <td>제공목적 달성 시</td>
                        </tr>
                        </tbody>
                    </table>
                    <br><br>
                  <!-- <p class="personal-txt">1) 회사는 원활한 개인정보 업무처리를 위하여 다음과 같이 개인정보 처리업무를 위탁하고 있습니다.<br>
                  2) 회사는 위탁계약 체결 시 「개인정보 보호법」 제26조에 따라 위탁업무 수행목적 외 개인정보 처리금지, 기술적・관리적 보호조치, 재위탁 제한, 수탁자에 대한 관리・감독, 손해배상 등 책임에 관한 사항을 계약서 등 문서에 명시하고, 수탁자가 개인정보를 안전하게 처리하는지 감독합니다.<br>
                  3) 「개인정보 보호법」 제26조제6항에 따라 수탁자가 당사의 개인정보 처리업무를 재위탁하는 경우 회사의 동의를 받습니다.<br>
                  4) 위탁업무의 내용이나 수탁자가 변경될 경우 지체없이 본 개인정보 처리방침을 통하여 공개하겠습니다.<br>
                  </p><br><br> -->
                  <p class="personal-title">4. 수집한 개인정보의 위탁</p><br>
                  <p class="personal-txt">
                  1) 회사는 원활한 개인정보 업무처리를 위하여 다음과 같이 개인정보 처리업무를 위탁하고 있습니다.
                  </p>
                  <table>
                    <thead>
                    <tr>
                      <th style="text-align: center">위탁받는 자(수탁자)</th>
                      <th style="text-align: center">위탁업무</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr><td>디에이인포메이션</td><td>웹사이트 및 시스템 관리</td></tr>
                  </tbody>
                  </table>
                  <br>
                  <p class="personal-txt">
                  2) 회사는 위탁계약 체결 시 「개인정보 보호법」 제26조에 따라 위탁업무 수행목적 외 개인정보 처리금지, 기술적・관리적 보호조치, 재위탁 제한, 수탁자에 대한 관리・감독, 손해배상 등 책임에 관한 사항을 계약서 등 문서에 명시하고, 수탁자가 개인정보를 안전하게 처리하는지 감독합니다.<br>
                  3) 「개인정보 보호법」 제26조제6항에 따라 수탁자가 당사의 개인정보 처리업무를 재위탁하는 경우 회사의 동의를 받습니다.<br>
                  4) 위탁업무의 내용이나 수탁자가 변경될 경우 지체없이 본 개인정보 처리방침을 통하여 공개하겠습니다.
                  </p>
                  <br><br>
                  <span class="personal-title">5. 개인정보의 안전성 확보조치</span><!-- //20241212_요기까지 이후 부터 다시 하기-->
                  <p class="personal-txt">1) 회사는 개인정보의 안전성 확보를 위해 다음과 같은 조치를 취하고 있습니다.</p>
                  <ul class="detail-list">
                    <li>(1) 관리적 조치: 정보보호 정책 및 지침 수립・시행, 전담조직 운영, 정기적 직원 교육, 년 2회 정보보호의 날 운영</li>
                    <li>(2) 기술적 조치: 개인정보처리시스템 등의 접근권한 관리, 접근통제시스템 설치, 개인정보의 암호화, 보안프로그램 설치 및 갱신, 취약성 진단 수행</li>
                    <li>(3) 물리적 조치: 전산실, 자료보관실 등 접근통제 적용</li>
                  </ul>

                  <p class="personal-txt">2) 회사는 개인정보의 안전성을 확보하기 위하여 법령에서 규정하고 있는 사항 이외에도 다음과 같은 활동을 시행하고 있습니다.</p>
                  <ul class="detail-list">
                    <li>(1) 개인정보보호 활동: 통합보고서 발간(연1회)</li>
                    <li>(2) 국내・외 정보보호 및 개인정보보호 인증 획득(ISO/IEC 27001, ISO/IEC 27701)</li>
                    <li>(3) 정보보호 공시</li>
                  </ul>
                  <br>

                  <p class="personal-title">6. 개인정보 자동수집 장치의 설치, 운영 및 그 거부에 관한 사항</p><br>
                  <p class="personal-txt">1) 회사는 사용자에게 개별적인 서비스와 편의를 제공하기 위해 이용정보를 저장하고 수시로 불러오는 ‘쿠키(cookie)’를 사용합니다.<br>
                    2) 쿠키는 웹사이트 운영에 이용되는 서버(http)가 정보주체의 브라우저에 보내는 소량의 정보이며 정보주체의 PC 또는 모바일에 저장됩니다.<br>
                    3) 정보주체는 웹 브라우저 옵션 설정을 통해 쿠키 허용, 차단 등의 설정을 할 수 있습니다. 다만, 쿠키 저장을 거부할 경우 맞춤형 서비스 이용에 어려움이 발생할 수 있습니다.
                    </p>

                    <p class="detail-sub-txt">▶ 웹 브라우저에서 쿠키 허용/차단<br>
                    - 크롬(Chrome) : 웹 브라우저 설정 > 개인정보 보호 및 보안 > 인터넷 사용 기록 삭제<br>
                    - 엣지(Edge) : 웹 브라우저 설정 > 쿠키 및 사이트 권한 > 쿠키 및 사이트 데이터 관리 및 삭제<br>
                    ▶ 모바일 브라우저에서 쿠키 허용/차단<br>
                    - 크롬(Chrome) : 모바일 브라우저 설정 > 개인정보 보호 및 보안 > 인터넷 사용 기록 삭제<br>
                    - 사파리(Safari) : 모바일 기기 설정 > 사파리(Safari) > 고급 > 모든 쿠키 차단<br>
                    - 삼성 인터넷 : 모바일 브라우저 설정 > 인터넷 사용 기록 > 인터넷 사용 기록 삭제
                    </p>

                  <br>
                  <p class="personal-title">7. 정보주체와 법정대리인의 권리・의무 및 그 행사방법</p><br>
                  <p class="personal-txt">
                    1) 정보주체는 회사의 CLEAN :D 서비스에 대해 언제든지 개인정보 열람・정정・삭제・처리정지 및 철회 요구, 자동화된 결정에 대한 거부 또는 설명 요구 등의 권리를 행사(이하 “권리 행사)할 수 있습니다.<br>
                    2) 권리 행사는 회사에 대해 「개인정보 보호법」 시행령 제41조제1항에 따라 서면, 전자우편, 모사전송(FAX) 등을 통하여 하실 수 있으며, 회사는 이에 대해 지체없이 조치하겠습니다.<br>
                    - 제보 내용 철회 방법 작성<br>
                    3) 권리 행사는 정보주체의 법정대리인이나 위임을 받은 자 등 대리인을 통하여 하실 수도 있습니다. 이 경우 “개인정보 처리 방법에 대한 고시” 별지 제11호 서식에 따른 위임장을 제출하셔야 합니다.<br>
                    4) 정보주체가 개인정보 열람 및 처리 정지를 요구할 권리는 「개인정보 보호법」제35조제4항 및 제37조제2항에 의하여 제한될 수 있습니다.<br>
                    5) 다른 법령에서 그 개인정보가 수집 대상으로 명시되어 있는 경우에는 해당 개인정보의 삭제를 요구할 수 없습니다.<br>
                    6) 자동화된 결정이 이루어진다는 사실에 대해 정보주체의 동의를 받았거나, 계약 등을 통해 미리 알린 경우, 법률에 명확히 규정이 있는 경우에는 자동화된 결정에 대한 거부는 인정되지 않으며 설명 및 검토 요구만 가능합니다.<br>
                    - 또한 자동화된 결정에 대한 거부・설명 요구는 다른 사람의 생명・신체・재산과 그 밖의 이익을 부당하게 침해할 우려가 있는 등 정당한 사유가 있는 경우에는 그 요구가 거절될 수 있습니다.<br>
                    7) 회사는 권리 행사를 한 자가 본인이거나 정당한 대리인인지를 확인합니다.<br>
                    8) 회사는 권리 행사를 아래의 부서에 할 수 있습니다. 회사는 정보주체의 권리 행사가 신속하게 처리되도록 노력하겠습니다.<br>
                    </p>
                    <br><p class="detail-sub-txt">▶ 개인정보 열람 등 청구 접수・처리 부서<br>
                  - 부서명 : 동아쏘시오홀딩스 윤리경영실 감사팀<br>
                  - 주 소 : 서울시 동대문구 천호대로64<br>
                  - 연락처 : 02-920-8081, audit@donga.co.kr
                  </p>
                  <br>

                  <p class="personal-title">8. 개인정보 보호책임자</p><br>
                  <p class="personal-txt">1) 회사는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와 가이 개인정보 책임자를 지정하고 있습니다.</p>
                    <p class="detail-sub-txt">
                      ▶ 개인정보 보호책임자<br>
                    - 성명 : 오무환 상무<br>
                    - 연락처 : 02-920-8015, audit@donga.co.kr</p><br>
                      <p class="detail-sub-txt">
                    ▶ 개인정보보호 담당부서<br>
                    - 부서명 : 경영진단팀<br>
                    - 연락처 : 02-920-8084, privacy_hd@donga.co.kr<br>
                    ※ 개인정보보호 담당부서로 연결됩니다.</p>

                  <br>
                  <p class="personal-txt">2) 정보주체는 회사의 CLEAN:D 서비스을 이용하시면서 발생한 모든 개인정보보호 관련 문의, 불만처리, 피해구제 등에 관한 사항을 개인정보 보호책임자 및 담당부서로 문의할 수 있습니다. 회사는 정보주체의 문의에 대해 지체없이 답변 및 처리해드릴 것입니다.</p>
                  <br>

                  <p class="personal-title">9. 개인정보 처리방침의 변경</p><br>
                  <p class="personal-txt">① 이 개인정보 처리방침은 2024. 12. 17부터 적용됩니다.</p>
                  <p class="personal-txt">② 이전의 개인정보 처리방침은 아래에서 확인하실 수 있습니다.</p>
                    <p class="detail-sub-txt">- v1.1: 2022년12월26일 ~ 2024년 12월17일 적용  <button type="button" class="button_click" @click="open_v3()">(클릭)</button></p>
                    <p class="detail-sub-txt">- v1.0: 2020년 6월 1일 ~ 2022년 12월 25일 적용 <button type="button" class="button_click" @click="open_v2()">(클릭)</button>
                    </p>

                  <br>
                </div>

                <div class="modal-btn-area">
                  <button type="button" class="modal-btn-cancle" @click="close()">닫기</button>
                </div>
            </h3>
        </modal>
         <!-- v1.1 클릭 시 팝업-->
         <modal  v-if="showModal_v3" @close="showModal_v3=false">
            <h3 slot="body">
                <div class="form-modal-container personal-popup">
                  <p class="personal-header">개인정보 처리 방침</p><br><br>
                  동아쏘시오그룹 감사 제보시스템(audit.donga.co.kr, 이하 “CLEAN :D”)는 고객의 개인정보 보호를<br>
                  매우 중요시 하며, ‘CLEAN :D’에서 제공하는 서비스를 언제나 고객께서 안심하고 사용하실 수 있도록<br>
                  최선을 다하고 있습니다. ‘CLEAN :D’는 개인정보처리방침을 통하여 고객님께서 제공하시는 개인정보가<br>
                  어떠한 용도와 방식으로 이용되고 있으며, <p class="personal-bold">개인정보보호를 위해 어떠한 조치가 취해지고 있는지 알려드립니다.<br>
                  또한 회사는 개인정보처리방침을 개정하는 경우, 웹사이트 공지사항 (또는 개별공지)을 통하여 공지할 것입니다.<br>
                  * 본 방침은 : 2022년 12월 26일 부터 시행됩니다.</p>
                  <br><br>
                  <span class="personal-title">1. 개인정보의 수집 항목 및 목적</span>
                  <p class="personal-txt">Clean :D는 서비스 제공을 위해 아래와 같은 개인정보를 수집하고 있습니다.</p>
                  <p class="detail-sub-txt">• 개인정보 수집 항목 : 이름, 주소, 전화번호, 이메일, 접속 IP, 서비스 이용 기록</p>
                  <p class="detail-sub-txt">• 개인정보 수집 및 이용 목적 : 필요 시 제보 내용 추가 확인, 접수 확인 안내 등 업무처리</p>
                  <p class="detail-sub-txt">• 개인정보 제공을 원하지 않을 경우는 ‘익명’으로 제보할 수 있으나, 제보 접수 확인 등 업무 처리에 제약이 있을 수 있습니다.</p>
                  <br>
                  <span class="personal-title">2. 개인정보의 보유 및 이용기간</span>
                  <p class="personal-txt">‘CLEAN :D’를 통해 수집된 개인정보는 원칙적으로 개인정보 수집 및 이용목적이 달성된 후에는 해당 정보를 지체 없이 파기합니다.<br>단, 다음의 정보에 대해서는 아래의 이유를 명시한 기간 동안 보존합니다.</p>
                  <p class="detail-tit">2-1. 회사 내부 방침에 의한 보존</p>
                  <ul class="detail-list">
                    <li>o 불량 이용자의 재가입 방지, 명예훼손 등 권리침해 분쟁 및 수사협조 : 1년</li>
                    <li>o 온라인문의 : 문의사항이 등록 후 1년이 지난 시점></li>
                    <li>o 관계법령 위반에 따른 수사, 조사 등이 진행중인 경우에는 해당 수사, 조사 종료 시 까지</li>
                  </ul>
                  <p class="detail-tit">2-2. 관련법령에 의한 보존</p>
                  <ul class="detail-list">
                    <li>o 대금결제 및 재화 등의 공급에 관한 기록 : 5년 (전자상거래 등에서의 소비자보호에 관한 법률)</li>
                    <li>o 소비자의 불만 또는 분쟁처리에 관한 기록 : 3년 (전자상거래 등에서의 소비자보호에 관한 법률)</li>
                  </ul>
                  <br>
                  <span class="personal-title">3. 개인정보 위탁 및 제3자 제공에 관한 사항</span>
                  <p class="personal-txt">‘CLEAN :D’는 개인정보를 “개인정보의 수집 목적”에서 고지한 범위 내에서 이용하며, 정보주체의 사전 동의가 있는 경우 제보 처리를 위해 다음과 같이 관련 회사에 제공할 수 있습니다.</p>
                  <p class="detail-sub-txt">• 개인정보의 제3자 제공</p>
                  <ul class="detail-list">
                    <li>o 제공받는 자: 동아에스티, 동아제약, 에스티젠바이오, 동아오츠카, 용마로지스, 에스티팜, 수석, 한국신동, 동천수, 참메드, 디에이인포메이션, 아벤종합건설</li>
                    <li>o 제공받는 개인정보: 수집하는 개인정보 항목과 같음</li>
                    <li>o 보유 및 이용기간: 개인정보 처리 및 보유기간 내용과 같음</li>
                  </ul>
                  <br>
                  <span class="personal-title">4. 수집한 개인정보의 위탁</span>
                  <p class="personal-txt">‘CLEAN :D’는 서비스 이행을 위해 아래와 같이 개인정보(관리정보)를 위탁하고 있으며, 관계 법령에 따라 위탁계약 시 개인정보가 안전하게 관리될 수 있도록 필요한 사항을 규정하고 있습니다.</p>
                  <p class="detail-sub-txt">• 수탁업체 : ㈜디에이인포메이션</p>
                  <p class="detail-sub-txt">• 위탁업무 내용 : 웹 사이트 및 시스템 관리</p>
                  <br>
                  <span class="personal-title">5. 정보주체의 권리.의무 및 그 행사방법에 관한 사항</span>
                  <p class="detail-sub-txt">• 정보주체는 ‘CLEAN :D’에 대해 언제든지 다음 각 호의 개인정보 보호 관련 권리를 행사할 수 있습니다.</p>
                  <ul class="detail-list">
                    <li>o 개인정보 열람요구</li>
                    <li>o 오류 등이 있을 경우 정정</li>
                    <li>o 삭제요구</li>
                    <li>o 처리정지 요구</li>
                  </ul>
                  <p class="detail-sub-txt">• 정보주체의 권리 행사는 회사에 대해 서면, 전화, 이메일(e-mail), Fax 등을 통하여 하실 수 있으며 회사는 이에 대해 지체 없이 조치하겠습니다.</p>
                  <p class="detail-sub-txt">• 정보주체가 개인정보의 오류 등에 대한 정정 또는 삭제를 요구한 경우에는 회사는 정정 또는 삭제를 완료할 때까지 당해 개인정보를 이용하거나 제공하지 않습니다.</p>
                  <p class="detail-sub-txt">• 정보주체의 권리 행사는 정보주체의 법정대리인이나 위임을 받은 자 등 대리인을 통하여 하실 수 있습니다. 이 경우 개인정보 보호법 시행규칙 별지 제11호 서식에 따른 위임장을 제출하셔야 합니다.</p>
                  <p class="detail-sub-txt">• 정보주체는 개인정보 보호법 등 관계법령을 위반하여 회사가 처리하고 있는 정보주체 본인이나 타인의 개인정보 및 사생활을 침해하여서는 아니 됩니다.</p>
                  <br>
                  <span class="personal-title">6. 개인정보 파기에 관한 사항</span>
                  <p class="personal-txt">‘CLEAN :D’는 원칙적으로 보유기간 경과, 처리목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체 없이 해당 개인정보를 파기합니다.</p>
                  <p class="detail-sub-txt">• 파기절차</p>
                  <ul class="detail-list">
                    <li>회사는 파기사유가 발생한 개인정보를 개인정보 보호책임자의 책임 하에 파기업무를 수행합니다.</li>
                  </ul>
                  <p class="detail-sub-txt">• 파기방법</p>
                  <ul class="detail-list">
                    <li>회사에서 처리하는 개인정보파일은 전자적 파일 형태로 기록되기 때문에 재생할 수 없는 기술적 방법을 사용하여 파기합니다.</li>
                  </ul>
                  <br>
                  <p class="personal-title">7. 개인정보의 안전성 확보조치에 관한 사항</p>
                  <p class="personal-txt">‘CLEAN :D’는 개인정보를 처리함에 있어 개인정보가 분실, 도난, 누출, 변조 또는 훼손되지 않도록 안전성 확보를 위하여 다음과 같은 대책을 강구하고 있습니다.</p>
                  <p class="detail-sub-txt">• 기술적 조치</p>
                  <ul class="detail-list">
                    <li>제보자의 모든 개인정보는 접근권한 관리, 접근통제시스템 설치, 고유식별정보 등의 암호화, 보안프로그램 설치를 통하여 안전하게 보관, 관리되고 있습니다. 또한 개인정보를 안전하게 전송하는 보안장치를 적용하고 있습니다.</li>
                  </ul>
                  <p class="detail-sub-txt">• 물리적 조치</p>
                  <ul class="detail-list">
                    <li>침입차단시스템을 이용하여 외부로부터의 무단 접근을 통제하고 있으며, 기타 시스템적으로 안전성을 확보하기 위해 필요한 통제 장치를 갖추려 노력하고 있습니다.</li>
                  </ul>
                  <p class="detail-sub-txt">• 관리적 조치</p>
                  <ul class="detail-list">
                    <li>‘CLEAN :D’는 개인정보 처리자의 최소화 운영 및 내부관리계획 수립∙시행하고 있습니다. 또한 개인정보 보호의 인식 제고를 위하여 정기적인 직원 교육을 수행하며, 개인정보 처리자는 업무 담당자에 한정하여 운영하고 이를 위한 별도의 패스워드를 부여하고 있습니다.</li>
                  </ul>
                  <br>
                  <p class="personal-title">8. 개인정보 자동수집 장치의 설치, 운영 및 그 거부에 관한 사항</p><br>
                  <p class="personal-txt">회사는 귀하의 정보를 수시로 저장하고 찾아내는 ‘쿠키(cookie)’ 등을 운용합니다. 쿠키란 웹사이트를 운영하는데 이용되는 서버가 귀하의 브라우저에 보내는 아주 작은 텍스트 파일로 귀하의 컴퓨터 하드디스크에 저장됩니다. 회사는 다음과 같은 목적을 위해 쿠키를 사용합니다.</p>
                  <p class="detail-sub-txt">• 쿠키의 사용 목적</p>
                  <ul class="detail-list">
                    <li>이용자가 방문한 각 서비스와 웹 사이트들에 대한 방문 및 이용형태, 보안접속 여부 등을 파악하여 이용자에게 최적화된 정보 제공을 위해 사용됩니다.<br></li>
                  </ul>
                  <p class="detail-sub-txt">• 쿠키의 설치∙운영 및 거부</p>
                  <ul class="detail-list">
                    <li>귀하는 쿠키 설치에 대한 선택권을 가지고 있습니다. 따라서, 귀하는 사용하시는 웹 브라우저의 옵션을 선택함으로써 모든 쿠키를 허용하거나 쿠키를 저장할 때마다 확인을 거치거나, 모든 쿠키의 저장을 거부할 수 있습니다.</li>
                    <li>설정방법 예(인터넷 익스플로어의 경우) : 웹 브라우저 상단의 도구 > 인터넷 옵션 > 개인정보</li>
                    <li>단, 귀하께서 쿠키 설치를 거부하였을 경우 서비스 제공에 어려움이 있을 수 있습니다.</li>
                  </ul>
                  <br>
                  <p class="personal-title">9. 개인정보 보호 및 개인정보 접수∙처리 담당부서</p><br>
                  <p class="personal-txt">‘CLEAN :D’는 고객의 개인정보를 보호하고 개인정보와 관련된 불만을 처리하기 위하여 아래와 같이 담당 부서 및 개인정보 보호책임자를 지정하고 있습니다.</p>
                  <p class="detail-sub-txt">• 개인정보 담당부서 안내</p>
                  <table class="personal-table">
                    <th></th>
                    <th style="text-align: center;">개인정보 접수∙처리 담당</th>
                    <th style="text-align: center;">개인정보 보호 담당</th>
                    <tr>
                      <td>이름</td>
                      <td>정현도 수석</td>
                      <td>윤보영 수석</td>
                    </tr>
                    <tr>
                      <td>소속</td>
                      <td>감사실</td>
                      <td>경영진단팀</td>
                    </tr>
                    <tr>
                      <td>전화번호</td>
                      <td>02-920-8081</td>
                      <td>02-920-8083</td>
                    </tr>
                    <tr>
                      <td>메일</td>
                      <td>kissmeq@donga.co.kr</td>
                      <td>yby7811@donga.co.kr</td>
                    </tr>
                  </table>
                  <p class="detail-sub-txt">• 개인정보 보호책임자 : 정보보호최고책임자(CISO)</p>
                  <ul class="detail-list">
                    <li>o 전화 : 02-920-8015</li>
                    <li>o 문의처 : audit@donga.co.kr</li>
                  </ul>
                  <p class="detail-sub-txt">• 기타기관</p>
                  <ul class="detail-list">
                    <li>고객께서는 회사의 서비스를 이용하며 발생한 개인정보 보호와 관련된 모든 민원을 개인정보 보호책임자 혹은 담당 부서로 신고할 수 있습니다. 회사는 이용자의 신고사항에 대해 신속하고 충분한 답변을 드릴 것입니다. 기타 개인정보 침해에 대해 신고나 상담이 필요한 경우에는 아래 기관에 문의하시기 바랍니다.</li>
                    <li style="padding-left: 20px;">o 개인정보침해 신고센터 (https://privacy.kisa.or.kr / 국번 없이 118)</li>
                    <li style="padding-left: 20px;">o 대검찰청 과학수사부 사이버수사과 (http://cybercid.spo.go.kr / 국번 없이 1301)</li>
                    <li style="padding-left: 20px;">o 경찰청 사이버안전국 (http://cyberbureau.police.go.kr / 국번 없이 182)</li>
                  </ul>
                  <br>
                  <p class="personal-title">10. 변경에 따른 공지의무</p><br>
                  <p class="personal-txt">법령, 정책 또는 보안기술의 변경에 따라 내용의 추가, 삭제 및 수정이 있을 시에는 변경되는 개인정보처리방침을 본사 홈페이지를 통해 변경이유 및 내용 등을 공지하도록 하겠습니다.</p>
                  <br>또한, 고객님은 이전의 개인정보처리방침을 아래에서 확인하실 수 있습니다.
                  <br><br>
                  <ul class="detail-list">
                    <li>개인정보처리방침 이력<br></li>
                  </ul>
                  <p class="detail-sub-txt">• v1.0: 2020년 6월 1일 ~ 2022년 12월 25일 적용 <button type="button" class="button_click" @click="open_v2()">(클릭)</button></p>
                </div>
                <div class="modal-btn-area">
                  <button type="button" class="modal-btn-cancle" @click="close()">닫기</button>
                </div>
            </h3>
        </modal>

        <!-- v1.0 클릭 시 팝업-->
        <modal v-if="showModal_v2" @close="showModal_v2=false">
            <h3 slot="body">
                <div class="form-modal-container personal-popup">
                  <p class="personal-header">개인정보 처리 방침</p><br><br>
                  동아쏘시오그룹 감사 제보시스템(audit.donga.co.kr, 이하 “CLEAN :D”)는 고객의 개인정보 보호를<br>
                  매우 중요시 하며, ‘CLEAN :D’에서 제공하는 서비스를 언제나 고객께서 안심하고 사용하실 수 있도록<br>
                  최선을 다하고 있습니다. ‘CLEAN :D’는 개인정보처리방침을 통하여 고객님께서 제공하시는 개인정보가<br>
                  어떠한 용도와 방식으로 이용되고 있으며, <p class="personal-bold">개인정보보호를 위해 어떠한 조치가 취해지고 있는지 알려드립니다.<br>
                  또한 회사는 개인정보처리방침을 개정하는 경우, 웹사이트 공지사항 (또는 개별공지)을 통하여 공지할 것입니다.<br>
                  * 본 방침은 : 2020년 6월 1일 부터 시행됩니다.</p>
                  <br><br>
                  <span class="personal-title">1. 개인정보의 수집 항목 및 목적</span>
                  <p class="personal-txt">Clean :D는 서비스 제공을 위해 아래와 같은 개인정보를 수집하고 있습니다.</p>
                  <p class="detail-sub-txt">• 개인정보 수집 항목 : 이름, 주소, 전화번호, 이메일, 접속 IP, 서비스 이용 기록</p>
                  <p class="detail-sub-txt">• 개인정보 수집 및 이용 목적 : 필요 시 제보 내용 추가 확인, 접수 확인 안내 등 업무처리</p>
                  <p class="detail-sub-txt">• 개인정보 제공을 원하지 않을 경우는 ‘익명’으로 제보할 수 있으나, 제보 접수 확인 등 업무 처리에 제약이 있을 수 있습니다.</p>
                  <br>
                  <span class="personal-title">2. 개인정보의 보유 및 이용기간</span>
                  <p class="personal-txt">‘CLEAN :D’를 통해 수집된 개인정보는 원칙적으로 개인정보 수집 및 이용목적이 달성된 후에는 해당 정보를 지체 없이 파기합니다.<br>단, 다음의 정보에 대해서는 아래의 이유를 명시한 기간 동안 보존합니다.</p>
                  <p class="detail-tit">2-1. 회사 내부 방침에 의한 보존</p>
                  <ul class="detail-list">
                    <li>o 불량 이용자의 재가입 방지, 명예훼손 등 권리침해 분쟁 및 수사협조 : 1년</li>
                    <li>o 온라인문의 : 문의사항이 등록 후 1년이 지난 시점></li>
                    <li>o 관계법령 위반에 따른 수사, 조사 등이 진행중인 경우에는 해당 수사, 조사 종료 시 까지</li>
                  </ul>
                  <p class="detail-tit">2-2. 관련법령에 의한 보존</p>
                  <ul class="detail-list">
                    <li>o 대금결제 및 재화 등의 공급에 관한 기록 : 5년 (전자상거래 등에서의 소비자보호에 관한 법률)</li>
                    <li>o 소비자의 불만 또는 분쟁처리에 관한 기록 : 3년 (전자상거래 등에서의 소비자보호에 관한 법률)</li>
                  </ul>
                  <br>
                  <span class="personal-title">3. 개인정보 위탁 및 제3자 제공에 관한 사항</span>
                  <p class="personal-txt">‘CLEAN :D’는 개인정보를 “개인정보의 수집 목적”에서 고지한 범위 내에서 이용하며, 정보주체의 사전 동의가 있는 경우 제보 처리를 위해 다음과 같이 관련 회사에 제공할 수 있습니다.</p>
                  <p class="detail-sub-txt">• 개인정보의 제3자 제공</p>
                  <ul class="detail-list">
                    <li>o 제공받는 자: 동아에스티, 동아제약, 에스티젠바이오, 동아오츠카, 용마로지스, 에스티팜, 수석, 한국신동, 동천수, 참메드, 디에이인포메이션, 아벤종합건설</li>
                    <li>o 제공받는 개인정보: 수집하는 개인정보 항목과 같음</li>
                    <li>o 보유 및 이용기간: 개인정보 처리 및 보유기간 내용과 같음</li>
                  </ul>
                  <br>
                  <span class="personal-title">4. 수집한 개인정보의 위탁</span>
                  <p class="personal-txt">‘CLEAN :D’는 서비스 이행을 위해 아래와 같이 개인정보(관리정보)를 위탁하고 있으며, 관계 법령에 따라 위탁계약 시 개인정보가 안전하게 관리될 수 있도록 필요한 사항을 규정하고 있습니다.</p>
                  <p class="detail-sub-txt">• 수탁업체 : ㈜디에이인포메이션</p>
                  <p class="detail-sub-txt">• 위탁업무 내용 : 웹 사이트 및 시스템 관리</p>
                  <br>
                  <span class="personal-title">5. 정보주체의 권리.의무 및 그 행사방법에 관한 사항</span>
                  <p class="detail-sub-txt">• 정보주체는 ‘CLEAN :D’에 대해 언제든지 다음 각 호의 개인정보 보호 관련 권리를 행사할 수 있습니다.</p>
                  <ul class="detail-list">
                    <li>o 개인정보 열람요구</li>
                    <li>o 오류 등이 있을 경우 정정</li>
                    <li>o 삭제요구</li>
                    <li>o 처리정지 요구</li>
                  </ul>
                  <p class="detail-sub-txt">• 정보주체의 권리 행사는 회사에 대해 서면, 전화, 이메일(e-mail), Fax 등을 통하여 하실 수 있으며 회사는 이에 대해 지체 없이 조치하겠습니다.</p>
                  <p class="detail-sub-txt">• 정보주체가 개인정보의 오류 등에 대한 정정 또는 삭제를 요구한 경우에는 회사는 정정 또는 삭제를 완료할 때까지 당해 개인정보를 이용하거나 제공하지 않습니다.</p>
                  <p class="detail-sub-txt">• 정보주체의 권리 행사는 정보주체의 법정대리인이나 위임을 받은 자 등 대리인을 통하여 하실 수 있습니다. 이 경우 개인정보 보호법 시행규칙 별지 제11호 서식에 따른 위임장을 제출하셔야 합니다.</p>
                  <p class="detail-sub-txt">• 정보주체는 개인정보 보호법 등 관계법령을 위반하여 회사가 처리하고 있는 정보주체 본인이나 타인의 개인정보 및 사생활을 침해하여서는 아니 됩니다.</p>
                  <br>
                  <span class="personal-title">6. 개인정보 파기에 관한 사항</span>
                  <p class="personal-txt">‘CLEAN :D’는 원칙적으로 보유기간 경과, 처리목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체 없이 해당 개인정보를 파기합니다.</p>
                  <p class="detail-sub-txt">• 파기절차</p>
                  <ul class="detail-list">
                    <li>회사는 파기사유가 발생한 개인정보를 개인정보 보호책임자의 책임 하에 파기업무를 수행합니다.</li>
                  </ul>
                  <p class="detail-sub-txt">• 파기방법</p>
                  <ul class="detail-list">
                    <li>회사에서 처리하는 개인정보파일은 전자적 파일 형태로 기록되기 때문에 재생할 수 없는 기술적 방법을 사용하여 파기합니다.</li>
                  </ul>
                  <br>
                  <p class="personal-title">7. 개인정보의 안전성 확보조치에 관한 사항</p>
                  <p class="personal-txt">‘CLEAN :D’는 개인정보를 처리함에 있어 개인정보가 분실, 도난, 누출, 변조 또는 훼손되지 않도록 안전성 확보를 위하여 다음과 같은 대책을 강구하고 있습니다.</p>
                  <p class="detail-sub-txt">• 기술적 조치</p>
                  <ul class="detail-list">
                    <li>제보자의 모든 개인정보는 접근권한 관리, 접근통제시스템 설치, 고유식별정보 등의 암호화, 보안프로그램 설치를 통하여 안전하게 보관, 관리되고 있습니다. 또한 개인정보를 안전하게 전송하는 보안장치를 적용하고 있습니다.</li>
                  </ul>
                  <p class="detail-sub-txt">• 물리적 조치</p>
                  <ul class="detail-list">
                    <li>침입차단시스템을 이용하여 외부로부터의 무단 접근을 통제하고 있으며, 기타 시스템적으로 안전성을 확보하기 위해 필요한 통제 장치를 갖추려 노력하고 있습니다.</li>
                  </ul>
                  <p class="detail-sub-txt">• 관리적 조치</p>
                  <ul class="detail-list">
                    <li>‘CLEAN :D’는 개인정보 처리자의 최소화 운영 및 내부관리계획 수립∙시행하고 있습니다. 또한 개인정보 보호의 인식 제고를 위하여 정기적인 직원 교육을 수행하며, 개인정보 처리자는 업무 담당자에 한정하여 운영하고 이를 위한 별도의 패스워드를 부여하고 있습니다.</li>
                  </ul>
                  <br>
                  <p class="personal-title">8. 개인정보 자동수집 장치의 설치, 운영 및 그 거부에 관한 사항</p><br>
                  <p class="personal-txt">회사는 귀하의 정보를 수시로 저장하고 찾아내는 ‘쿠키(cookie)’ 등을 운용합니다. 쿠키란 웹사이트를 운영하는데 이용되는 서버가 귀하의 브라우저에 보내는 아주 작은 텍스트 파일로 귀하의 컴퓨터 하드디스크에 저장됩니다. 회사는 다음과 같은 목적을 위해 쿠키를 사용합니다.</p>
                  <p class="detail-sub-txt">• 쿠키의 사용 목적</p>
                  <ul class="detail-list">
                    <li>이용자가 방문한 각 서비스와 웹 사이트들에 대한 방문 및 이용형태, 보안접속 여부 등을 파악하여 이용자에게 최적화된 정보 제공을 위해 사용됩니다.<br></li>
                  </ul>
                  <p class="detail-sub-txt">• 쿠키의 설치∙운영 및 거부</p>
                  <ul class="detail-list">
                    <li>귀하는 쿠키 설치에 대한 선택권을 가지고 있습니다. 따라서, 귀하는 사용하시는 웹 브라우저의 옵션을 선택함으로써 모든 쿠키를 허용하거나 쿠키를 저장할 때마다 확인을 거치거나, 모든 쿠키의 저장을 거부할 수 있습니다.</li>
                    <li>설정방법 예(인터넷 익스플로어의 경우) : 웹 브라우저 상단의 도구 > 인터넷 옵션 > 개인정보</li>
                    <li>단, 귀하께서 쿠키 설치를 거부하였을 경우 서비스 제공에 어려움이 있을 수 있습니다.</li>
                  </ul>
                  <br>
                  <p class="personal-title">9. 개인정보 보호 및 개인정보 접수∙처리 담당부서</p><br>
                  <p class="personal-txt">‘CLEAN :D’는 고객의 개인정보를 보호하고 개인정보와 관련된 불만을 처리하기 위하여 아래와 같이 담당 부서 및 개인정보 보호책임자를 지정하고 있습니다.</p>
                  <p class="detail-sub-txt">• 개인정보 담당부서 안내</p>
                  <table class="personal-table">
                    <th></th>
                    <th style="text-align: center;">개인정보 접수∙처리 담당</th>
                    <th style="text-align: center;">개인정보 보호 담당</th>
                    <tr>
                      <td>이름</td>
                      <td>정현도 수석</td>
                      <td>박성근 수석</td>
                    </tr>
                    <tr>
                      <td>소속</td>
                      <td>감사실</td>
                      <td>정보윤리팀</td>
                    </tr>
                    <tr>
                      <td>전화번호</td>
                      <td>02-920-8081</td>
                      <td>02-920-8084</td>
                    </tr>
                    <tr>
                      <td>메일</td>
                      <td>kissmeq@donga.co.kr</td>
                      <td>gepijol@donga.co.kr</td>
                    </tr>
                  </table>
                  <p class="detail-sub-txt">• 개인정보 보호책임자 : 정보보호최고책임자(CISO)</p>
                  <ul class="detail-list">
                    <li>o 전화 : 02-920-8015</li>
                    <li>o 문의처 : audit@donga.co.kr</li>
                  </ul>
                  <p class="detail-sub-txt">• 기타기관</p>
                  <ul class="detail-list">
                    <li>고객께서는 회사의 서비스를 이용하며 발생한 개인정보 보호와 관련된 모든 민원을 개인정보 보호책임자 혹은 담당 부서로 신고할 수 있습니다. 회사는 이용자의 신고사항에 대해 신속하고 충분한 답변을 드릴 것입니다. 기타 개인정보 침해에 대해 신고나 상담이 필요한 경우에는 아래 기관에 문의하시기 바랍니다.</li>
                    <li style="padding-left: 20px;">o F (https://privacy.kisa.or.kr / 국번 없이 118)</li>
                    <li style="padding-left: 20px;">o 대검찰청 과학수사부 사이버수사과 (http://cybercid.spo.go.kr / 국번 없이 1301)</li>
                    <li style="padding-left: 20px;">o 경찰청 사이버안전국 (http://cyberbureau.police.go.kr / 국번 없이 182)</li>
                  </ul>
                </div>
                <div class="modal-btn-area">
                  <button type="button" class="modal-btn-cancle" @click="close()">닫기</button>
                </div>
            </h3>
        </modal>
        <ISOModal v-if="showISO" @close="showISO=false">
          <h3 slot="body">
            <img src="../img/iso-popup.jpg" alt="iso popup">
            <div class="modal-btn-area">
              <button type="button" class="modal-btn-cancle" @click="showISO=false">닫기</button>
            </div>
          </h3>
        </ISOModal>
      </div>
    </footer>
</template>
<script>
import Modal from '@/components/FooterModal'
import ISOModal from '@/components/ISOModal'
export default {
  name: 'AuditFooter',
  components: {
    'modal': Modal,
    'ISOModal': ISOModal
  },
  data () {
    return {
      showModal: false,
      showISO: false,
      showModal_v2: false,
      showModal_v3: false
    }
  },
  methods: {
    open () {
      this.showModal = true
    },
    close () {
      this.showModal = false
      this.showModal_v2 = false
      this.showModal_v3 = false
    },
    open_v2 () {
      this.showModal_v2 = true
    },
    open_v3 () {
      this.showModal_v3 = true
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../css/sub.scss';

.button_click{
  color:#990033;
  font-weight: bold;
  font-size:15px;
}

.personal-popup{
  .personal-title{
    display:block;
    color:#990033;
    font-weight: bold;
    font-size:15px;
  }
 .personal-txt{
   display:block;
   color:#000;
   font-size:14px;
   margin-bottom:5px;
 }
 .detail-tit{
    display:block;
    color:#990033;
    font-weight: bold;
    font-size:15px;
    padding-left:20px;
    padding-top:5px;
 }
 .detail-sub-txt{
    display:block;
    font-size:14px;
    padding-left:20px;
    padding-bottom: 5px;
 }
 .detail-list{
   padding-left:40px;
   li{
     display:block;
     padding-top:2px;
     &:last-child{
       margin-bottom:10px;
     }
   }
 }
 table {
  border: 1px solid black;
  border-collapse: collapse;
  width: 70%;
  text-align: center;
  th, td{
   border: 1px solid black;
  }
 }
 .personal-table{
   margin-left: 40px;
   margin-bottom: 10px;
 }
}
.audit-footer{
  display:flex;
  background:#e6e6e6;
  position:relative;
  // padding:20px;
  flex-direction: column;
  text-align: center;
  .logo{
    display:block;
    max-width:130px;
    margin:20px auto;
  }
  .foot-address{
    font-size:12px;
    line-height:21px;
    font-style: normal;
    font-weight: bold;
    color:#686868;
  }
  .foot-personal{
    display: table;
    width: 100%;
    vertical-align: middle;
    border-bottom: 1px solid #ffffff;
    border-left: none;
    border-right: none;
    padding: 10px 0;
    padding-left: 15px;
    margin-bottom: 20px;
    text-align: left;
  }
  .foot-personal .foot-personal-btn{
    font-weight: bold;
    font-size: 15px;
  }
  .foot-desc{
    position:relative;
    display: block;
    width:100%;
  }
  .form-modal-container{
    text-align: left;
    overflow-y: auto;
    font-size: 13px;
    font-weight: normal;
    max-height:400px;
    .personal-header{
      text-align: center !important;
      font-weight: bold;
      font-size: 25px;
    }
    .personal-bold{
      font-weight: bold;
      display: contents;
    }
  }
  .iso-logo{
    position:absolute;
    display:block;
    top:0;
    right:20px;
    width:80px;
  }
}
@media (min-width: 1200px) {
  .audit-footer{
    padding-bottom: 40px;
    .pc-container{
      display:flex;
      flex-direction: row;
      flex-wrap: wrap;
    }
    .logo{
      display:flex;
      margin:0;
      align-items: center;
      position: absolute;
      top: 0;
      left: 0;
      max-width:100%;
    }
    .foot-address{
      flex:1;
      font-size:13px;
      font-weight: normal;
      line-height:1.425;
      padding-top:10px;
    }
    .form-modal-container{
      max-height: 650px;
      font-size: 17px;
    }
    .personal-popup{
      .personal-title{
        font-size:18px;
      }
      .personal-txt{
        font-size:17px;
      }
      .detail-tit{
        font-size:18px;
      }
      .detail-sub-txt{
        font-size:17px;
      }
    }
    .iso-logo{
      top:0;
      width:127px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AuditFooter.vue